

import { useLocale } from "next-intl";

/**
 * Returns an Intl-compatible locale string from next-intl's current locale.
 * Replaces hardcoded "de-DE" locale strings throughout slotting components.
 */
export function useUserLocale(): string {
  return useLocale();
}
